import { createContext } from 'react';

const scoreColorTypeContext = createContext(null);

export default scoreColorTypeContext;
